module.exports = __webpack_public_path__ + "static/photo-rishit-kedia-16889506a76269da2a9a2e6d898d9655.png";